<template>
  <div class="layout-wrapper layout-2">
    <div class="layout-inner">
      <app-layout-sidenav />

      <div class="layout-container">
        <app-layout-navbar />

        <div class="layout-content">
          <div class="layout-main">
            <div class="router-transitions flex-grow-1">
              <div class="router-view">
                <router-view />
              </div>
            </div>

            <app-layout-footer />
          </div>
        </div>
      </div>
    </div>
    <div class="layout-overlay" @click="closeSidenav"></div>
  </div>
</template>

<script>
import LayoutNavbar from './LayoutNavbar'
import LayoutSidenav from './LayoutSidenav'
import LayoutFooter from './LayoutFooter'

export default {
  name: 'app-layout-2',
  components: {
    'app-layout-navbar': LayoutNavbar,
    'app-layout-sidenav': LayoutSidenav,
    'app-layout-footer': LayoutFooter
  },

  mounted () {
    this.layoutHelpers.init()
    this.layoutHelpers.update()
    this.layoutHelpers.setAutoUpdate(true)
  },

  beforeDestroy () {
    this.layoutHelpers.destroy()
  },

  methods: {
    closeSidenav () {
      this.layoutHelpers.setCollapsed(true)
    }
  }
}
</script>
<style lang="scss" scoped>
.layout-content {
  flex: 1;
  overflow-y: hidden;
}
.router-view {
  width: 100%;
  height: 100%;
  overflow: auto;
}
.layout-main {
  overflow: hidden;
  height: 100%;
  /*padding-top: 4.5rem*/
  display: flex;
  flex-direction: column;
  min-width: 400px;
}
.router-transitions {
  padding: 0 !important;
  flex: 1;
  overflow: hidden;
  /*min-height: 93.55%;*/
}
</style>